import { GzJsonViewerWebComponent } from './component/GzJsonViewerWebComponent';
import { WEB_COMPONENT_GZ_JSON_VIEWER } from '../../webcomponents.constants';

export { GzJsonViewerWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_JSON_VIEWER, GzJsonViewerWebComponent);
